module.exports = __webpack_public_path__ + "img/caesars-forum.5dbdd7ff.png";